export default __webpack_public_path__ + "static/media/emp-id-16px.25aade80.svg";